import { createBrowserHistory } from 'history';
import once from "../cache/once";

class HistoryProvider {
    public getHistory = once(createBrowserHistory);
}

export default new HistoryProvider();
